/*
 * @Author: hujingyang
 * @Date: 2021-01-14 14:03:40
 * @Description: 订单筛选营销/订单筛选/订单生命周期监控
 * @LastEditors: xutingting
 * @LastEditTime: 2021-05-21 17:06:40
 * @FilePath: \DouYinStore\src\pages\OrderSelection\components\Chart_OrderLifeCycleMonitoring\index.tsx
 * @IDE: Created by VScode.
 */
import React, { useEffect, useState } from 'react';
import { Progress, Tab, Tag } from '@alifd/next';
import style from './index.module.scss';
import { LineChart } from 'bizcharts';
import { Servlets } from '@/service';
import utils from '@/common/utils';
import hasNoDate from '@/assets/has-no-date.png';
// AreaChart 面积图

const TabItem = Tab.Item;
const TagGroup = Tag.Group;
const SelectableTag = Tag.Selectable;

// 订单数据拉不到时，24Hcharts图显示坐标
const scale = {
  total: {
    min: 0,
    max: 40,
    tickCount: 4,
  },
};

/** 订单筛选营销/订单筛选/订单生命周期监控 */
const Chart_OrderLifeCycleMonitoring = (): JSX.Element => {
  const [currentTabKey, setCurrentTabKey] = useState('today');// tabs默认高亮设置
  const [allLineChartDate, setAllLineChartDate] = useState([] as object[]); // 24Hchart图所有数据的存储
  const [lineChartData, setLineChartData] = useState([] as object[]);// 图标数据
  const [orderData, setOrderData] = useState({
    // orderNum - 订单数 //orderProportion - 订单占比
    unpaid: { name: '待支付订单', key: 'unpaid', orderNum: 0, orderProportion: 0, checked: true }, // 待支付
    canceled: { name: '已取消订单', key: 'canceled', orderNum: 0, orderProportion: 0, checked: true }, // 已取消
    paid: { name: '已支付订单', key: 'paid', orderNum: 0, orderProportion: 0, checked: false }, // 已支付
    refund: { name: '退货订单', key: 'refund', orderNum: 0, orderProportion: 0, checked: false }, // 退货
  }); // 订单环比数据

  // 页面监听函数
  useEffect(() => {
    init();
  }, []);

  /** 初始化函数 */
  const init = (): void => {
    getDataSource();
  };

  /** 获取数据 */
  const getDataSource = (): void => {
    // 获取订单折线图数据
    getLineChartData(currentTabKey, orderData).then((res) => {
      console.log('第一次数据', res);
      setLineChartData(res);
    });

    // 获取订单环比数据
    getOrderData().then((res) => {
      setOrderData(res);
    });
  };

  /**
   *  页面tabs切换时触发
   * @param tabKey
   */
  const changeTabs = (tabKey): void => {
    // 这个功能废弃
    return;
    setCurrentTabKey(tabKey);
    getLineChartData(tabKey).then((res) => {
      setLineChartData(res);
    });
  };

  /**
   * 获取数据可视化-折线图数据
   * @param currentTabKey 当前已选tab
   * @param OrderData 当前的环比数据 -- 用于判断折线图显示哪几条线
   */
  const getLineChartData = async (currentTabKey: string, OrderData: any = orderData): Promise<object[]> => {
    let result = [{ time: '', type: '', value: 0 }];
    if (lineChartData.length) {
      // 如果已经获取过数据了，下次请求直接使用上次获取的数据
      return packageDataLineChart(allLineChartDate, OrderData);
    }

    await Servlets('getOrderlifecycle', {}).then((res: { data: object[] }) => {
      /**
       * "data": [
       {
            "cancelledOrderCount": 0,//已取消
            "createTime": "string",
            "id": 0,
            "paidOrderCount": 0,//已支付
            "returnOrderCount": 0,//退货
            "unpaidOrderCount": 0//待支付
          }
       ],
       */
      setAllLineChartDate(res.data);
      result = packageDataLineChart(res.data, OrderData);
    });

    return result;

    // let result = [{ time: "", type: "", value: 0 }]
    // for (let index = 0; index < 24; index++) {

    //   const unpaid = {
    //     time: `${index < 10 ? '0' : ''}${index}:${index % 2 ? '00' : '30'}`,//"01:30",
    //     type: "unpaid", // unpaid- 待支付 canceled - 已取消
    //     value: parseInt(Math.random() * 100 + '')
    //   }
    //   if (OrderData.unpaid.checked) result.push(unpaid);


    //   const paid = {
    //     time: `${index < 10 ? '0' : ''}${index}:${index % 2 ? '00' : '30'}`,//"01:30",
    //     type: "paid", // unpaid- 待支付 canceled - 已取消
    //     value: parseInt(Math.random() * 100 + '')
    //   }
    //   if (OrderData.paid.checked) result.push(paid);


    //   const canceled = {
    //     time: `${index < 10 ? '0' : ''}${index}:${index % 2 ? '00' : '30'}`,//"01:30",
    //     type: "canceled", // unpaid- 待支付 canceled - 已取消
    //     value: parseInt(Math.random() * 100 + '')
    //   }
    //   if (OrderData.canceled.checked) result.push(canceled);

    //   const refund = {
    //     time: `${index < 10 ? '0' : ''}${index}:${index % 2 ? '00' : '30'}`,//"01:30",
    //     type: "refund", // unpaid- 待支付 canceled - 已取消
    //     value: parseInt(Math.random() * 100 + '')
    //   }
    //   if (OrderData.refund.checked) result.push(refund);
    // }
  };

  /**
   * 封装图表数据
   * @param data 接口获取的数据
   * @param OrderData 图标配置信息
   */
  const packageDataLineChart = (data, OrderData) => {
    const result = [{ createTime: '', type: '', value: 0 }];
    if (lineChartData.length) {

    }
    data.forEach((item) => {
      /** unpaid- 待支付 */
      const unpaid = { createTime: item.createTime, type: 'unpaid', value: item.unpaidOrderCount };
      if (OrderData.unpaid.checked) result.push(unpaid);

      /** paid- 已支付 */
      const paid = { createTime: item.createTime, type: 'paid', value: item.paidOrderCount };
      if (OrderData.paid.checked) result.push(paid);

      /** canceled - 已取消 */
      const canceled = { createTime: item.createTime, type: 'canceled', value: item.cancelledOrderCount };
      if (OrderData.canceled.checked) result.push(canceled);

      /** returnOrderCount - 退货 */
      const refund = { createTime: item.createTime, type: 'refund', value: item.returnOrderCount };
      if (OrderData.refund.checked) result.push(refund);
    });

    result.shift();
    return result;
  };

  /** 获取订单环比数据 */
  const getOrderData = async (): Promise<any> => {
    let orderDataTemp;

    //  获取订单数据
    await Servlets('getOrderlifecyclesum', {}).then((res: { data: { cancelledOrderSum: number; paidOrderSum: number; returnOrderSum: number; unpaidOrderSum: number } }) => {
      const { cancelledOrderSum, paidOrderSum, returnOrderSum, unpaidOrderSum } = res.data;

      const sum = eval(Object.values(res.data).join('+'));

      orderDataTemp = {
        unpaid: {
          ...orderData.unpaid,
          ...{
            orderNum: unpaidOrderSum,
            orderProportion: utils.numberTransform(unpaidOrderSum / sum),
          },
        }, // 待支付
        canceled: {
          ...orderData.canceled,
          ...{
            orderNum: cancelledOrderSum,
            orderProportion: utils.numberTransform(cancelledOrderSum / sum),
          },
        }, // 已取消
        paid: {
          ...orderData.paid,
          ...{
            orderNum: paidOrderSum,
            orderProportion: utils.numberTransform(paidOrderSum / sum),
          },
        }, // 已支付
        refund: {
          ...orderData.refund,
          ...{
            orderNum: returnOrderSum,
            orderProportion: utils.numberTransform(returnOrderSum / sum),
          },
        }, // 退货
      };
    });
    return orderDataTemp;
  };
  /** 设置checkBox点选状态 */
  const setCheckBox = ([checked, id]): void => {
    const tempOrderData = JSON.parse(JSON.stringify(orderData));
    tempOrderData[id].checked = checked;
    setOrderData(tempOrderData);
    getLineChartData(currentTabKey, tempOrderData).then((res) => {
      setLineChartData(res);
    });
  };

  /** 防抖函数 */
  const responseFunc = (func, ...argu) => {
    utils.debounceImmediately(func)(argu);
  };
  return (
    <>
      <section className="orderLifeCycleMonitoring">
        <div className={style.mainBox}>

          <Tab
            size="small"
            shape="text"
            navClassName="orderLifeCycleMonitoring_tabs"
            onChange={changeTabs}
            defaultActiveKey={currentTabKey}
            animation
          >
            <TabItem title="今日（实时）" key="today" />
            {/* <TabItem title="昨日（历史）" key="yesterday" /> */}
          </Tab>

          {/* 环形盘 进度展示 */}
          <section>

            <div className={style.orderProgressBar}>
              {/* 方案一 */}
              {/* ES5语法 兼容IE/// 缺点：容易产生魔法字符串 优点：兼容IE */}
              {/* {
                Object.keys(orderData).map((key, index) => {
                  return (
                  <TagGroup>
                      <SelectableTag
                        className={style.selectableTag}
                        checked={item.checked}
                        onChange={(checked) => { setCheckBox(checked, item.key) }}
                        type="normal"
                      >
                        <div key={index} className={style.bar} >
                          <div className={style.orderCheck}>
                            <div className={style.title}>
                              <span className={style.title_name}>{item.name}</span>
                              <span className={style.title_orderNum}>{item.orderNum}</span>
                            </div>
                            <Progress percent={item.orderProportion * 100} size="medium" color="#5D4CFF" textRender={() => ''} />
                            <div className={style.orderProportion}>占比:{item.orderProportion * 100}%</div>
                          </div>
                        </div>
                      </SelectableTag>
                    </TagGroup>
                  )
                })
              } */}

              {/* 方案二 */}
              {/* ES8语法 //// 缺点：不兼容IE 优点：主流浏览语法糖，语法简洁容易复用 */}

              {
                Object.values(orderData).map((item, index) => {
                  return (
                    <TagGroup key={index}>
                      <SelectableTag
                        className={style.selectableTag}
                        checked={item.checked}
                        onChange={(checked) => responseFunc(setCheckBox, checked, item.key, 'a')}
                        type="normal"
                      >
                        {/*  // {setCheckBox(checked, item.key) */}
                        <div className={style.bar}>
                          <div className={style.orderCheck}>
                            <div className={style.title}>
                              <span className={style.title_name}>{item.name}</span>
                              <span
                                className={style.title_orderNum}
                              >{item.orderNum}
                              </span>
                            </div>
                            <Progress
                              percent={item.orderProportion * 100}
                              size="medium"
                              color="#5D4CFF"
                              textRender={() => ''}
                            />
                            <div
                              className={style.orderProportion}
                            >占比:{item.orderProportion}%
                            </div>
                          </div>
                        </div>
                      </SelectableTag>
                    </TagGroup>
                  );
                })
              }
            </div>
          </section>

          {/* 24H订单监控  折线图 */}
          <section style={{ marginBottom: 12 }}>
            {
              lineChartData.length > 0 && <LineChart
                data={lineChartData}
                meta={{
                  type: {
                    formatter: (v) => {
                      return { unpaid: '待支付', canceled: '已取消', paid: '已支付', refund: '退货' }[v];
                    },
                  },
                }}
                title={{ visible: true, text: '24H订单监控' }}
                legend={{ visible: true, position: 'top-right' }}
                xField="createTime"
                yField="value"
                seriesField="type"
                interactions={[{ type: 'slider', cfg: { start: 0, end: 1 } }]}
                smooth
              />
            }
            {
              !lineChartData.length && <>
                <div className={style['hours-order-effect']}>24H订单监控</div>
                <div style={{ textAlign: 'center', marginTop: '71px' }}>
                  <img src={hasNoDate} />
                </div>
              </>
            }
          </section>
        </div>
      </section>
    </>
  );
};

export default Chart_OrderLifeCycleMonitoring;
